import { LoaderFunction, useFetcher } from "react-router-dom";
import { getInstructorCourses } from "common/api/tightrope/methods";

export const getInstructorCoursesLoader: LoaderFunction = async ({
  params,
}) => {
  if (params.sessionId) {
    return getInstructorCourses(params.sessionId);
  }
};

export function useInstructorCoursesFetcher() {
  return useFetcher<Awaited<ReturnType<typeof getInstructorCourses>>>();
}
